/**
 * This file is auto-generated
 */
export const biAnalyticsApiMethods = [
    'reportAnonymousUserAnalyticEvent',
    'reportRegisteredUserAnalyticEvent',
];
//# sourceMappingURL=bi-analytics-api.js.map